import scientia_image from "../images/scientia-image.png";
import './Hero.less';

interface HeroProps {
  currentUser: any;
}

const Hero: React.FC<HeroProps> = ({ currentUser }) => {
  if (!currentUser) {
    return (
      <div className="Hero">
        <div className="text">
          <div className="scientia-hero">EMSL Science Central<sup style={{fontSize: "12px", position: "absolute"}}>TM</sup></div> 
          <div className="h3-hero">
          Convergence of Innovation, Collaboration, and Scientific Discovery
          </div>
        </div>
        <div className="image">
          <img
            className="scientia-image"
            src={scientia_image}
            height="100%"
            alt="scientia-image"
          />
        </div>
      </div>
    );
  } else {
    return (
    <div className="hero-loggedout-spacer"></div>
    );
  }
};

export default Hero;
